var CertificateApplicationPolicies_1;
import { __decorate } from "tslib";
import { CertificatePolicies } from "@peculiar/asn1-x509";
import { AsnType, AsnTypeTypes } from "@peculiar/asn1-schema";
export const id_certificateApplicationPolicies = "1.3.6.1.4.1.311.21.10";
let CertificateApplicationPolicies = CertificateApplicationPolicies_1 = class CertificateApplicationPolicies extends CertificatePolicies {
    constructor(items) {
        super(items);
        Object.setPrototypeOf(this, CertificateApplicationPolicies_1.prototype);
    }
};
CertificateApplicationPolicies = CertificateApplicationPolicies_1 = __decorate([
    AsnType({ type: AsnTypeTypes.Sequence })
], CertificateApplicationPolicies);
export { CertificateApplicationPolicies };
